import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { CoesOfferEntityNormalized } from '../../../../../../../../../store/product/types';
import { CoesAssetProvider } from '../../../../../contexts/products/Coes';
import { ItemDetails } from '../Details';

import { CoesListItemDesktop } from './desktop';
import { CoesListItemMobile } from './mobile';
import { CoesListItemTablet } from './tablet';

export namespace CoesListItemTypes {
  export interface Props {
    offer: CoesOfferEntityNormalized;
  }
}

export const CoesListItem: React.FC<CoesListItemTypes.Props> = ({ offer }) => {
  const directTreasuryListItem = useBreakpointValue({
    base: <CoesListItemMobile offer={offer} />,
    sm: <CoesListItemTablet offer={offer} />,
    lg: <CoesListItemDesktop offer={offer} />,
  });

  return (
    <CoesAssetProvider>
      <ItemDetails />
      {directTreasuryListItem}
    </CoesAssetProvider>
  );
};
